module.exports = __webpack_public_path__ + "img/iStock-1061013482.69341a27.jpg";